'use strict';

angular.module('fileUpload', [])
// - Es la directiva que crea el campo para el drag-n-drop.
// - Para utilizarlo agregas el atributo drop-file.
// - En caso de que necesites agregar 2 archivos en la misma forma agrega el
//   atributo "file-id" y asignale un valor que sera un nombre que se le dara al
//   archivo que se suba desde ese campo drag-n-drop.
// - Si necesitas cambiar el tamaño de la cajita, puedes agregar un id al div con
//   con la directiva y desde CSS seleccionarlo asi:
//
//        div#id #dropbox{ width:500px};
//                  ^ representa el cuadro donde se puede arrastrar un archivo.
.directive('dropFile', [function () {
    return {
        restrict: 'A',
        scope:true,
        template: '<div class="dropbox {{modifierClass}}">'+
        '<div id="drop-box" class="dropbox__box">'+
        '<span ng-if="fileName">{{fileName}}</span>'+
        '<span ng-if="!fileName">{{dropboxCaption}}</span>'+
        '<label for="{{fileID}}" class="dropbox__link" ng-hide="isReady" propagation-off>seleccionalo</label>'+
        '<input type="file" id="{{fileID}}" class="dropbox__fileInput" name="file-select" accept="{{fileType}}">'+
        '</div>',
        controller: function($scope, fileUploadService){

            // Reset file inputs, credits to ibralnet,
            // from: http://www.sencha.com/forum/showthread.php?14817-Reset-the-input-type-file-field-to-blank
            $scope.clearFileInputs = function(id){
                var fileField = document.getElementById(id);
                var parentNod = fileField.parentNode;
                var tmpForm = document.createElement("form");
                parentNod.replaceChild(tmpForm,fileField);
                tmpForm.appendChild(fileField);
                tmpForm.reset();
                parentNod.replaceChild(fileField,tmpForm);
            };


            $scope.$on('dataSentFinish', function(e, arg){
                if(arg.result === 'OK')
                {
                    $scope.clearFileInputs($scope.fileID);
                    $scope.fileName = null;
                    $scope.isReady = false;
                }
            });

            $scope.fileDragHover = function(e){
                e.stopPropagation();
                e.preventDefault();
                if(e.target.id == 'drop-box' )
                    e.target.className =  (e.type == "dragover") ? "drop-box hover":"drop-box";
            };

            $scope.fileSelected = function(e){
                $scope.fileDragHover(e);
                var files = e.target.files || e.dataTransfer.files;
                $scope.isReady = true;
                $scope.fileName = files[0].name;
                fileUploadService.addFiles(files[0], $scope.fileID);
                $scope.$apply();
            };

        },
        link: function (scope, dropBox, attrs) {
            //Directive Parameters
            scope.fileID = attrs.fileId;
            scope.modifierClass = attrs.dropboxClass;
            scope.dropboxCaption = (attrs.dropboxCaption) ? attrs.dropboxCaption + ' ' : 'Arrastra el archivo aqui o ';
            if (angular.isString(attrs.fileType) && attrs.fileType.length > 0) {
                scope.fileType = attrs.fileType;
            }
            //Add event listener for drag-n-drop events
            dropBox.find('input')[0].addEventListener('change', scope.fileSelected, false);
            dropBox[0].addEventListener('dragover', scope.fileDragHover, false);
            dropBox[0].addEventListener('dragleave', scope.fileDragHover, false);
            dropBox[0].addEventListener('drop', scope.fileSelected, false);

            scope.$watch('isReady', function(newVal, oldVal){
                if(newVal)
                {
                    if(!dropBox.hasClass('selected'))
                    {
                        dropBox.toggleClass('selected');
                    }
                }
                else
                {
                    dropBox.removeClass('selected');
                }
            },true);
        }
    };
}])
// Esta directiva se la pones a la forma que va a incluir los archivos,
// En el $scope de tu controlador declara 2 funciones:
// 1.- formSuccessCB : Se ejecuta cuando la llamada fue exitosa.
// 2.- formErrorCB : Se ejecuta cuando la llamada tuvo un error.
// 
// Para definir nombre de archivos obligatorios usa la directiva "required-files",
// en lista el nombre de los archivos requeridos separados por espacios
//      required-files="logo logoAltaCalidad"
//
//
// Para agregar validacion al formulario tienes que agregar la directiva validacion="true"
// Si hay un error en los campos se ejectua la funcion callback de error y envia el siguiente objeto:
//          {error:501, form:formConErrores}
// 
// Si hay el error es que falte agregar algun archivo se ejecuta la funcion callback de error y envia el siguiente objeto:
//          {error:500}


.directive('fileForm', [function () {
    return {
        restrict: 'A',
        scope:true,
        controller: function($scope, fileUploadService){
            $scope.required = function(arr){
                fileUploadService.setRequiredFiles(arr);
            };

            $scope.submitForm = function () {
                if($scope.validacion)
                {
                    if ($scope.formData && $scope[$scope.formName].$valid) {
                        fileUploadService.sendFilesAndData($scope.uploadFormData, $scope.endpoint, $scope.formSuccessCB, $scope.formErrorCB, $scope.numRequired);
                    }
                    else{
                        $scope.formErrorCB({error:501, form:$scope[$scope.formName]});
                    }
                }
                else
                {
                    fileUploadService.sendFilesAndData($scope.uploadFormData, $scope.endpoint, $scope.formSuccessCB, $scope.formErrorCB, $scope.numRequired);
                }
            };
        },
        link: function (scope, form, attrs) {

          scope.$watch(() => attrs.endpoint, endpoint => scope.endpoint = endpoint);
            //scope.endpoint = attrs.endpoint;
            scope.formData = attrs.fileForm == "true";
            scope.formName = attrs.name;
            if(attrs.success)
            {
                scope.successCB = attrs.success;
            }

            if(attrs.error)
            {
                scope.errorCB = attrs.error;
            }

            if (scope.formData && attrs.requiredFiles)
            {
                var arr = attrs.requiredFiles.split(' ');
                scope.required(arr);
            }

            if(attrs.numberOfFilesRequired)
            {
                scope.numRequired = parseInt(attrs.numberOfFilesRequired);
            }
            else
            {
                scope.numRequired = 1;
            }

            if(attrs.validacion)
            {
                scope.validacion = scope.$eval(attrs.validacion);
            }
        }
    };
}])
.service('fileUploadService',function ($rootScope, $http) {
    var files = {};
    var requiredFiles = [];
    var otherData = {};
    var numFilesRequired = 1;

    return {
        addFiles:function(fileObj, name){
            fileObj.fileID = name;
            files[name] = fileObj;
        },
        setRequiredFiles: function(files){
            requiredFiles = files;
        },
        setNumberRequired: function(num){
            numFilesRequired = num;
        },
        addOtherData: function(name,data){
            otherData[name] = data;
        },
        sendFilesAndData:function(model, endpoint, successCB, errorCB, numFilesRequired){
            $rootScope.$broadcast('dataSentStart');
            var numOfFiles = 0;
            for(var a in files)
            {
                numOfFiles++;
            }

            if(numOfFiles >= numFilesRequired)
            {
                if(requiredFiles.length > 0)
                {
                    for(var i=0; i<requiredFiles.length;i++)
                    {
                        if(!files[requiredFiles[i]])
                        {
                            files[requiredFiles[i]] = {fileID:requiredFiles[i]};
                        }
                    }
                }
                for(var key in otherData)
                {
                    model[key] = otherData[key];
                }
                var promise = $http({
                    method: 'POST',
                    url: '../../../servicios/PortalServicio.svc/'+endpoint,
                    headers:{'Content-Type':false},
                    transformRequest: function(data){
                        
                        var formData = new FormData();
                        for(var key in data.model)
                        {
                            formData.append(key, data.model[key]);
                        }

                        for(var name in data.files)
                        {
                            formData.append(data.files[name].fileID, data.files[name]);
                        }
                        return formData;
                    },
                    data: {model: model, files:files}
                    })
                    .then(function ({ data }){
                        successCB(data);
                        files = {};
                        $rootScope.$broadcast('dataSentFinish', {result:'OK'});
                    }, function ({ data }){
                        errorCB(data);
                        files = {};
                        $rootScope.$broadcast('dataSentFinish', {result:'ERROR'});
                    });
                return promise;
            }
            else
            {
                errorCB({error:500});
                $rootScope.$broadcast('dataSentFinish', {result:'ERROR'});
            }
        }
    };
});
